




































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import Holiday from "../../store/entities/booking/holiday";

@Component({
    components: {  }
})
export default class extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;

    holiday: Holiday = new Holiday();

    get holidayTypes() {
        return this.$store.state.common.holidayTypes;
    }
    save() {
        //console.log(JSON.stringify(this.holiday));
        (this.$refs.holidayForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await this.$store.dispatch({
                    type: "holiday/create",
                    data: this.holiday
                });
                (this.$refs.holidayForm as any).resetFields();

                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.holidayForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        }
    }

    holidayRule = {
        name: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("HolidayName")),
                trigger: "blur"
            },
            {
                type: 'string',
                max: 32,
                message: this.L("NoMoreThenLength",undefined,this.L("HolidayName"),"32"),
                trigger: "blur"
            }
        ],
        startDate: [
            {
                required: true,
                message: this.L("SelectIsRequired", undefined, this.L("StartDate")),
                trigger: "change"
            }
        ],
        endDate: [
            {
                required: true,
                message: this.L("SelectIsRequired", undefined, this.L("EndDate")),
                trigger: "change"
            }
        ]
    };
}
